import React from 'react';
import App from './components/App';
import ScrollToTop from 'components/ScrollToTop';
var Root = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(App, null),
        React.createElement(ScrollToTop, null)));
};
export default Root;
